<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave" @row-update="handleUpdate"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" size="small" icon="el-icon-plus" plain @click.stop="handleAdd()">新增售卖产品
          </el-button>
          <!-- <el-button
            type="danger"
            size="small"
            plain
            @click.stop="productDown"
          >下架
          </el-button> -->
          <el-button type="danger" size="small" icon="el-icon-sort" plain @click.stop="productPutAway">上/下架
          </el-button>
        </template>
        <template slot-scope="scope" slot="menuForm">
          <el-button type="primary" size="medium" icon="el-icon-circle-plus" v-if="scope.type === 'add'" plain
            style="position: relative;right: -85px;" @click="readyGroup">上架售卖</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="success" size="small" icon="el-icon-view" plain
            @click.stop="handleDetail(scope.row, scope.index)">查看
          </el-button>
          <el-button type="primary" size="small" icon="el-icon-edit" plain
            @click.stop="handleEdit(scope.row, scope.index)">编辑
          </el-button>
          <el-button type="danger" size="small" icon="el-icon-sort-down" plain v-if="scope.row.status == 'PUTAWAY'"
            @click.stop="singleProductDown(scope.row.id)">下架
          </el-button>
          <el-button type="danger" size="small" icon="el-icon-delete" plain v-if="scope.row.status == 'UNDERCARIAGE'"
            @click.stop="singleProductDel(scope.row.id)">删除
          </el-button>
          <el-button type="danger" size="small" icon="el-icon-sort-up" plain v-if="scope.row.status == 'UNDERCARIAGE'"
            @click.stop="singleProductPutAway(scope.row.id)">上架
          </el-button>
        </template>
        <template slot-scope="scope" slot="jbxxForm">
          <b style="position: relative;color: rgba(0,0,0,0.8);right: 88px;bottom: -13px;">1.基本信息</b>
        </template>
        <template slot-scope="scope" slot="smpsForm">
          <b style="position: relative;color: rgba(0,0,0,0.8);right: 88px;bottom: -13px;">2.售卖区域及配送信息</b>
        </template>
        <template slot-scope="scope" slot="spglForm">
          <b style="position: relative;color: rgba(0,0,0,0.8);right: 88px;bottom: -13px;">3.商品关联服务</b>
        </template>
        <template slot-scope="scope" slot="xxtxForm">
          <b style="position: relative;color: rgba(0,0,0,0.8);right: 88px;bottom: -13px;">4.消息提醒</b>
        </template>
        <template slot-scope="scope" slot="notifyStaffsForm">
          <el-select v-model="currservicePeople" placeholder="请选择提醒人员" multiple filterable remote
            :remote-method="remoteMethod">
            <el-option v-for="item2 in currservicePeoples" :key="item2.id" :label="item2.realName"
              :value="item2.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="provinceForm">
          <el-select v-model="currProvince" required filterable clearable multiple @change="chooseProvinces"
            placeholder="请选择省份" value-key="id">
            <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="cityForm">
          <el-select v-model="currCity" required filterable clearable multiple @change="chooseCitys" placeholder="请选择城市"
            value-key="id">
            <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="areaForm">
          <el-select v-model="currArea" required filterable clearable multiple @change="chooseAreas" placeholder="请选择地区"
            value-key="id">
            <el-option v-for="item in areas" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="goodsNameForm">
          <el-select v-model="currProduct" required filterable clearable :disabled="isEdit" @change="chooseProducts"
            placeholder="请选择产品" value-key="id">
            <el-option v-for="item in products" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="firstClassifyNameForm">
          <el-select v-model="classify" placeholder="请选择商品一级分类" required :disabled="isEdit"
            @change="chooseSecondClassify" value-key="id">
            <el-option v-for="classify in classifies" :key="classify.id" :label="classify.name"
              :value="classify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="secondClassifyNameForm">
          <el-select v-model="secondClassify" placeholder="请选择商品二级分类" :disabled="isEdit" required
            @change="findProductSkuClassify" value-key="id">
            <el-option v-for="secondClassify in secondClassifies" :key="secondClassify.id" :label="secondClassify.name"
              :value="secondClassify"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="skuForm">
          <el-select v-model="sku" placeholder="请选择SKU组合" :disabled="isEdit" required @change="findConstituteBySkuId"
            value-key="id">
            <el-option v-for="sku in skuList" :key="sku.id" :label="sku.skuName" :value="sku"></el-option>
          </el-select>
        </template>
        <template slot-scope="{}" slot="priceNameForm">
          <div style="display:flex;">
            <el-tooltip class="item" effect="dark" content="消费者在购买时将会看到价格名称，如统一售价、预付款等等." placement="top-start">
              <i class="el-icon-warning" style="position: relative;left: -8px;"></i>
            </el-tooltip>
            <el-input placeholder="请输入价格名称" v-model="form.priceName">

            </el-input>
          </div>
        </template>
        <!--<template slot-scope="scope" slot="agentIdForm">-->
        <!--<el-select v-model="department"-->
        <!--placeholder="请选择代理商"-->
        <!--required-->
        <!--value-key="dutyStuff">-->
        <!--<el-option v-for="department in departments" :key="department.dutyStuff"-->
        <!--:label="department.company"-->
        <!--:value="department"></el-option>-->
        <!--</el-select>-->
        <!--</template>-->
        <template slot-scope="scope" slot="joinsWorkServiceCategoryForm">
          <el-select v-model="joinsWorkServiceCategory" placeholder="请选择服务类目" required clearable
            @change="choseWorkServiceItem" value-key="id">
            <el-option v-for="joinsWorkServiceCategory in joinsWorkServiceCategorys" :key="joinsWorkServiceCategory.id"
              :label="joinsWorkServiceCategory.name" :value="joinsWorkServiceCategory"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="joinsWorkServiceItemForm">
          <el-select v-model="joinsWorkServiceItem" placeholder="请选择服务项目" required clearable @change="findCoupon"
            value-key="id">
            <el-option v-for="joinsWorkServiceItem in joinsWorkServiceItems" :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name" :value="joinsWorkServiceItem"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="couponForm">
          <el-select v-model="coupon" placeholder="请选择优惠券" required clearable @change="findCoupon" value-key="id">
            <el-option v-for="coupon in coupons" :key="coupon.id" :label="coupon.couponName"
              :value="coupon"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="productStatusForm">
          <div>
            <el-radio v-model="productStatus" label="PUTAWAY">上架</el-radio>
            <el-radio v-model="productStatus" label="UNDERCARIAGE">下架</el-radio>
          </div>
        </template>

        <template slot-scope="scope" slot="parentCommissionRateTypeForm">
          <el-select v-model="form.parentCommissionRateType" placeholder="请选择佣金类型" clearable @change="$forceUpdate()">
            <el-option label="金额" value="MONEY"></el-option>
            <el-option label="百分比" value="PERCENT"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="commissionRateTypeForm">
          <el-select v-model="form.commissionRateType" placeholder="请选择佣金类型" clearable @change="$forceUpdate()">
            <el-option label="金额" value="MONEY"></el-option>
            <el-option label="百分比" value="PERCENT"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="dispatchingForm">
          <div>

            <el-radio v-model="dispatching" label="EXPRESS">快递</el-radio>
            <el-radio v-model="dispatching" label="MERCHANT">商家配送</el-radio>
          </div>
        </template>
        <template slot-scope="scope" slot="describeImgsForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg,image/gif,image/png,image/bmp" :file-list="fileList"
            :http-request="fnUploadDescribeImgs" :show-file-list="false">
            <div v-if="'' != describeImgs" class="el-upload el-upload--picture-img">
              <img v-for="describeImg of describeImgs" :src="describeImg" :key="describeImg.id" style="width: 200px;" />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="wheelsImgsForm">
          <el-upload :multiple="true" action="#" accept="image/jpeg,image/gif,image/png,image/bmp"
            :file-list="fileList1" :http-request="fnUploadWheelsImgs" :show-file-list="false">
            <div v-if="'' != wheelsImgs" class="el-upload el-upload--picture-img">
              <img v-for="wheelsImg of wheelsImgs" :src="wheelsImg" :key="wheelsImg.id" style="width: 200px;" />
            </div>
            <div v-else class="el-upload el-upload--car-two">
              <i class="el-icon-plus"></i>
            </div>
            <div class="el-upload__tip">只能上传jpg/png，且不超过500kb</div>
          </el-upload>
        </template>
        <template slot-scope="scope" slot="productStatus">
          <el-tag v-for="obj of productStatuses" :key="obj.value" v-if="obj.value == scope.row.productStatus">
            {{ obj.label }}
          </el-tag>
        </template>
        <template slot-scope="scope" slot="constituteForm">
          <div>
            <i style="color:red;position: relative;left: -79px;">*</i>
            <el-table :data="constitutes" border>
              <template v-for='(col, index) in tableData1'>
                <el-table-column sortable :show-overflow-tooltip="true" :prop="col.dataItem" :label="col.dataName"
                  :key="col.dataItem" width="124px">
                  <template slot-scope="scope">
                    <el-input type="input" v-if="col.dataName === '价格'" :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"></el-input>
                    <!-- 优惠价格 -->
                    <el-input type="input" v-else-if="col.dataName === '优惠价'" :name="col.dataName"
                      v-model="scope.row[index]" :placeholder="col.placeholder"></el-input>
                    <el-input type="input" v-else-if="col.dataName === '消费者折扣'" :name="col.dataName"
                      v-model="scope.row[index]" :placeholder="col.placeholder"></el-input>
                    <el-input type="input" v-else disabled :name="col.dataName" v-model="scope.row[index]"
                      :placeholder="col.placeholder"></el-input>
                  </template>
                </el-table-column>
              </template>

              <!-- <el-table-column
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column> -->
            </el-table>
            <!-- <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div> -->
          </div>
        </template>
      </avue-crud>
      <el-dialog title="提示" :visible.sync="tipDialogVisible" width="30%" center>
        <span>{{ tipMessage }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tipDialogVisible = false">取 消</el-button>
          <el-button v-if="!isPass" type="primary" @click="errorTips">确 定</el-button>
          <el-button v-if="isPass" type="primary" @click="$refs.crud.rowSave()">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findUsersList } from "@/api/salesCloud/customerInfo";
import { commerceGoodsSaleOption } from "@/const/salesCloud/commerceGoodsSaleOption";
import {
  sellList,
  findSkuConstitute,
  addProductGoods,
  findProducts,
  verify,
  productDown,
  delProduct,
  productPutAway,
  updateProduct,
  findProductSkuClassify,
  findConstituteBySkuId,
  chooseSecondClassify,
} from "@/api/salesCloud/commerceGoodsSale";
import {
  findCategoryAll,
  findItemsByCategory,
} from "@/api/salesCloud/workOrder";
import { findCoupon } from "@/api/salesCloud/serviceCoupon";
import {
  provinceSelect,
  citySelect,
  areasSelect,
} from "@/api/sales/regionSelect";
import { findProject } from "@/api/work/dtTable";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import { findUserList } from "@/api/salesCloud/bindEngineer";
import oss from "ali-oss";
import md5 from "js-md5";

export default {
  name: "commerceGoodsSale",
  data() {
    return {
      tableOption: commerceGoodsSaleOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      productStatuses: DIC.PRODUCT_STATUS,
      brands: [],
      currservicePeople: [],
      currservicePeoples: [],
      currProduct: {},
      brand: {},
      classifies: [],
      classify: {},
      chooseType: "",
      secondClassifies: [],
      secondClassify: {},
      departments: [],
      department: {},
      isEdit: false,
      provinces: [],
      currProvince: [],
      citys: [],
      currCity: [],
      areas: [],
      currArea: [],
      isPass: false,
      isSELL: false,
      tipDialogVisible: false,
      form: {
        priceName: '',
        parentCommissionRateType: '',
        commissionRateType: '',
      },
      tipMessage: "",
      productStatus: "PUTAWAY",
      dispatching: "EXPRESS",
      describeImgs: [],
      wheelsImgs: [],
      fileList: [],
      fileList1: [],
      prices: [],
      clientTypes: DIC.CLIENT_TYPE,
      sku: {},
      skuList: [],
      tableData1: [],
      constitutes: [],
      dataSku1: [],
      joinsWorkServiceCategorys: [],
      joinsWorkServiceCategory: {},
      joinsWorkServiceItems: [],
      joinsWorkServiceItem: {},
      coupon: {},
      coupons: [],
    };
  },
  created() {
    findProducts().then((res) => {
      let data = JSON.parse(res.data);
      this.products = data;
    });
    // findCategoryAll().then(res => {
    //   let data = JSON.parse(res.data);
    //   this.joinsWorkServiceCategorys = data.rows;
    // });
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.joinsWorkServiceCategorys = data;
    });
    provinceSelect().then((res) => {
      // let data = JSON.parse(res.data);
      this.provinces = res.data;
    });
    // findAllSuperiorDepartment().then((res) => {
    //     let data = JSON.parse(res.data);
    //     this.departments = data
    // });
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    remoteMethod(query) {
      if (query.length == 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_AGENT",
            mobile: query,
          };
          findUserList(params).then((res) => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_AGENT",
            mobile: query,
          };
          findUserList(params).then((res) => {
            let data = JSON.parse(res.data);
            this.currservicePeoples = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    chooseProvinces() {
      this.currCity = [];
      this.citys = [];
      this.currArea = [];
      this.areas = [];
      if (this.currProvince.length == 1) {
        citySelect(this.currProvince).then((res) => {
          this.citys = res.data;
        });
      } else {
        this.citys = [];
      }
    },
    chooseCitys() {
      this.currArea = [];
      this.areas = [];
      if (this.currCity.length == 1) {
        areasSelect(this.currCity).then((res) => {
          this.areas = res.data;
        });
      } else {
        this.areas = [];
      }
    },
    chooseAreas() {
      // if (this.currArea.length == 1) {
      // }
    },
    errorTips() {
      this.$message({
        showClose: true,
        message: "发布失败",
        type: "error",
      });
      this.tipDialogVisible = false;
    },
    readyGroup() {
      if (this.isSELL == true) {
        this.tipDialogVisible = true;
        return;
      } else {
        this.$refs.crud.rowSave();
        this.tipDialogVisible = false;
      }
    },
    chooseProducts() {
      let verifyParams = {};
      verifyParams.goodsId = this.currProduct.id;
      verifyParams.type = "SELL";
      verify(verifyParams).then((res) => {
        if (res.code == "200") {
          this.isSELL = false;
        } else if (res.code == "260090007") {
          this.isSELL = true;
          this.isPass = false;
          this.tipMessage = res.message;
        } else if (res.code == "260090008") {
          this.isSELL = true;
          this.isPass = true;
          this.tipMessage = res.message;
        }
      });
      //选择时清空列表
      this.constitutes = [];
      findSkuConstitute(this.currProduct.skuId).then((res) => {
        let data = JSON.parse(res.data);
        //回显表头
        this.currProduct.skuConstitute = data;
        this.formatConstitute(this.currProduct.skuConstitute);
        this.sku = { id: this.currProduct.skuId };
        this.dataSku1 = this.currProduct.dataSku;
        for (let i = 0; i < this.currProduct.dataSku.length; i++) {
          let mapObj = new Map();
          let dataSku = this.currProduct.dataSku[i];
          let map = this.objToStrMap(dataSku);
          let arrayVal = map.get("skuValue").split(":");
          let tableData2 = this.tableData1;
          for (let j = 0; j < tableData2.length; j++) {
            let obj1 = tableData2[j];
            if (typeof obj1.id != "undefined") {
              mapObj.set(obj1.flag, arrayVal[obj1.flag]);
            } else {
              mapObj.set(obj1.flag, map.get(obj1.dataItem));
            }
          }
          this.constitutes.push(this.strMapToObj(mapObj));
        }
      });
    },
    handleAddRows() {
      let obj = "{";
      for (let i = 0; i < this.tableData1.length; i++) {
        if (i != this.tableData1.length - 1) {
          obj += "" + i + ":'',";
        } else {
          obj += "" + i + ":''";
        }
      }
      obj += "}";
      let dataObj = eval("(" + obj + ")");
      // let list = {
      //     price: '',
      //     goodsNumber:0,
      //     consumerDiscount:'',
      //     engineerDiscount:'',
      //     merchantDiscount:''
      // }
      this.constitutes.push(dataObj);
    },
    handleSteppingDelete(index, row) {
      this.constitutes.splice(index, 1);
      this.dataSku1.splice(index, 1);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.type = "SELL";
      params.isEngineer = "NO";
      params.page = this.page.currentPage;
      params.size = pageSize;
      sellList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      params.type = "SELL";
      params.isEngineer = "NO";
      sellList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.type = "SELL";
      params.isEngineer = "NO";
      sellList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      params.type = "SELL";
      params.isEngineer = "NO";
      sellList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.prices = [];
      this.clean();
      this.chooseType = "ADD";
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row)
      this.chooseType = "Edit";
      this.clean();
      //配送方式回显
      this.dispatching = row.dispatching;
      //产品名称,且不能编辑
      this.isEdit = true;
      this.currProduct.id = row.goodsId;
      //sku组合
      this.currProduct.skuId = row.skuId;
      this.currProduct.dataSku = row.dataSku;
      this.chooseProducts();
      //价格名称
      this.form.priceName = row.priceName;
      //佣金类型回显
      this.form.parentCommissionRateType = row.parentCommissionRateType;
      this.form.commissionRateType = row.commissionRateType;
      //服务类目回显
      this.joinsWorkServiceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      //服务项目回显
      this.joinsWorkServiceItem.id = row.serviceItemId;
      this.findCoupon();
      //优惠券id回显
      this.coupon.id = row.couponId;
      //提醒人员回显
      let params = {};
      params.id = row.notifyStaffs.join(",");
      findUsersList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let j of data) {
          this.currservicePeoples.push(j);
        }
        this.currservicePeople = row.notifyStaffs;
      });
      //区域选择回显
      if (
        row.province.split(",").length == 1 &&
        row.province.split(",") != ""
      ) {
        let id = row.province;
        this.currProvince = row.province.split(",");
        citySelect(id).then((res) => {
          this.citys = res.data;
        });
      } else if (row.province.length > 1) {
        this.currProvince = row.province.split(",");
      } else {
        this.currProvince = "";
      }
      if (row.city.split(",").length == 1 && row.city.split(",") != "") {
        let id = row.city;
        this.currCity = row.city.split(",");
        areasSelect(id).then((res) => {
          this.areas = res.data;
          this.currArea = row.area.split(",");
        });
      } else if (row.city.length > 1) {
        this.currCity = row.city.split(",");
      } else {
        this.currCity = "";
      }
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      params.type = "SELL";
      params.isEngineer = "NO";
      sellList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done, loading) {
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.id = this.currProduct.dataSku[i].id;
        sku.skuId = this.sku.id;
        dataSku.push(sku);
      }
      if (this.currservicePeople.length > 0) {
        row.notifyStaffs = this.currservicePeople;
      } else {
        this.$message({
          showClose: true,
          message: "至少要有一个提醒人",
          type: "error",
        });
        // done();
        loading();
        return;
      }
      row.dataSku = dataSku;
      row.brandId = this.brand.id;
      row.firstClassifyId = this.classify.id;
      row.secondClassifyId = this.secondClassify.id;
      row.productStatus = this.productStatus;
      row.dispatching = this.dispatching;
      row.agentId = this.department.dutyStuff;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      row.couponId = this.coupon.id;
      //
      row.type = "SELL";
      row.isEngineer = "NO";
      row.goodsId = this.currProduct.id;
      row.priceName = this.form.priceName;
      row.parentCommissionRateType = this.form.parentCommissionRateType;
      row.commissionRateType = this.form.commissionRateType;
      if (this.currProvince.length > 0) {
        row.province = this.currProvince.join(",");
      }
      if (this.currCity.length > 0) {
        row.city = this.currCity.join(",");
      }
      if (this.currArea.length > 0) {
        row.area = this.currArea.join(",");
      }
      addProductGoods(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            // this.tipDialogVisible = false;
            this.handleList();
            done();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            // this.tipDialogVisible = false;
            loading();
          }
        })
        .catch((error) => {
          this.loading = false;
          loading();
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      loading();
      // done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row, index) { },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      let dataSku = [];
      for (let i = 0; i < this.constitutes.length; i++) {
        let obj = this.constitutes[i];
        let strMap = new Map();
        for (let k of Object.keys(obj)) {
          strMap.set(k, obj[k]);
        }
        let ids = "";
        let val = "";
        let skuMap = new Map();
        for (let j = 0; j < this.tableData1.length; j++) {
          let obj1 = this.tableData1[j];
          if (typeof obj1.id != "undefined") {
            ids += obj1.id + ":";
            val += strMap.get(j + "") + ":";
          } else {
            skuMap.set(obj1.dataItem, strMap.get(obj1.flag + ""));
          }
        }
        let sku = Object.create(null);
        for (let [k, v] of skuMap) {
          sku[k] = v;
        }
        ids = ids.substring(0, ids.length - 1);
        val = val.substring(0, val.length - 1);
        if (sku.consumerDiscount == "") {
          delete sku.consumerDiscount;
        }
        sku.skuKey = ids;
        sku.skuValue = val;
        sku.id = row.dataSku[i].id;
        sku.skuId = this.sku.id;
        dataSku.push(sku);
      }
      row.dataSku = dataSku;
      row.brandId = this.brand.id;
      row.firstClassifyId = this.classify.id;
      row.secondClassifyId = this.secondClassify.id;
      row.productStatus = this.productStatus;
      row.dispatching = this.dispatching;
      row.agentId = this.department.dutyStuff;
      row.describeImgs = this.describeImgs;
      row.wheelsImgs = this.wheelsImgs;
      row.couponId = this.coupon.id;
      //
      row.type = "SELL";
      row.isEngineer = "NO";
      row.goodsId = this.currProduct.id;
      if (this.currservicePeople.length > 0) {
        row.notifyStaffs = this.currservicePeople;
      } else {
        this.$message({
          showClose: true,
          message: "至少要有一个提醒人",
          type: "error",
        });
      }
      row.priceName = this.form.priceName;
      row.parentCommissionRateType = this.form.parentCommissionRateType;
      row.commissionRateType = this.form.commissionRateType;
      if (this.currProvince.length > 0) {
        row.province = this.currProvince.join(",");
      } else {
        row.province = "";
      }
      if (this.currCity.length > 0) {
        row.city = this.currCity.join(",");
      } else {
        row.city = "";
      }
      if (this.currArea.length > 0) {
        row.area = this.currArea.join(",");
      } else {
        row.area = "";
      }
      updateProduct(row)
        .then((response) => {
          console.log(response)
          if (response.code == 200) {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
      this.handleList();
      done();
    },
    handleDetail(row, index) {
      this.chooseType = "Edit";
      this.clean();
      //配送方式回显
      this.dispatching = row.dispatching;
      //产品名称,且不能编辑
      this.isEdit = true;
      this.currProduct.id = row.goodsId;
      //sku组合
      this.currProduct.skuId = row.skuId;
      this.currProduct.dataSku = row.dataSku;
      this.chooseProducts();
      //价格名称
      this.form.priceName = row.priceName;
      //佣金类型回显
      this.form.parentCommissionRateType = row.parentCommissionRateType;
      this.form.commissionRateType = row.commissionRateType;
      //服务类目回显
      this.joinsWorkServiceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      //服务项目回显
      this.joinsWorkServiceItem.id = row.serviceItemId;
      this.findCoupon();
      //优惠券id回显
      this.coupon.id = row.couponId;
      //提醒人员回显
      let params = {};
      params.id = row.notifyStaffs.join(",");
      findUsersList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let j of data) {
          this.currservicePeoples.push(j);
        }
        this.currservicePeople = row.notifyStaffs;
      });
      //区域选择回显
      if (
        row.province.split(",").length == 1 &&
        row.province.split(",") != ""
      ) {
        let id = row.province;
        this.currProvince = row.province.split(",");
        citySelect(id).then((res) => {
          this.citys = res.data;
        });
      } else if (row.province.length > 1) {
        this.currProvince = row.province.split(",");
      } else {
        this.currProvince = "";
      }
      if (row.city.split(",").length == 1 && row.city.split(",") != "") {
        let id = row.city;
        this.currCity = row.city.split(",");
        areasSelect(id).then((res) => {
          this.areas = res.data;
          this.currArea = row.area.split(",");
        });
      } else if (row.city.length > 1) {
        this.currCity = row.city.split(",");
      } else {
        this.currCity = "";
      }
      this.$refs.crud.rowView(row, index);
    },
    chooseSecondClassify() {
      chooseSecondClassify(this.classify.id).then((res) => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
    },
    async fnUploadWheelsImgs(option) {
      if (this.wheelsImgs.length >= 5) {
        this.$message({
          showClose: true,
          message: "轮播图不能超过五张",
          type: "error",
        });
        return;
      }
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.wheelsImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => { });
      });
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => { });
      });
    },
    productDown() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productDown(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    productPutAway() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认上/下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          productPutAway(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    singleProductPutAway(id) {
      this.$confirm(`是否确认上架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productPutAway(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "上架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    singleProductDel(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          delProduct(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    singleProductDown(id) {
      this.$confirm(`是否确认下架?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          ids.push(id);
          productDown(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "下架成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    findProductSkuClassify() {
      let obj = {};
      obj.firstClassifyId = this.classify.id;
      obj.secondClassifyId = this.secondClassify.id;
      findProductSkuClassify(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.skuList = data;
      });
    },
    findConstituteBySkuId() {
      findConstituteBySkuId(this.sku.id).then((res) => {
        let data = JSON.parse(res.data);
        this.formatConstitute(data);
      });
    },
    formatConstitute(data) {
      let flag = 0;
      this.tableData1 = new Array(data.length + 2);
      for (let i = 0; i < data.length; i++) {
        let obj = {};
        obj.dataItem = data[i].constituteCode;
        obj.dataName = data[i].constituteName;
        obj.placeholder = data[i].constituteName;
        obj.id = data[i].id;
        obj.flag = flag;
        this.tableData1[flag] = obj;
        //this.tableData1.push(obj)
        flag++;
      }
      this.tableData1[flag] = {
        dataItem: "goodsNumber",
        dataName: "库存",
        placeholder: "库存",
        flag: flag,
      };
      this.tableData1[flag + 1] = {
        dataItem: "price",
        dataName: "价格",
        placeholder: "价格",
        flag: flag + 1,
      };
      this.tableData1[flag + 2] = {
        dataItem: "consumerActivityPrice",
        dataName: "优惠价",
        placeholder: "优惠价",
        flag: flag + 2,
      };
      this.tableData1[flag + 3] = {
        dataItem: "consumerDiscount",
        dataName: "消费者折扣",
        placeholder: "消费者折扣",
        flag: flag + 3,
      };
    },
    objToStrMap(obj) {
      let strMap = new Map();
      for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k]);
      }
      return strMap;
    },
    strMapToObj(strMap) {
      let obj = Object.create(null);
      for (let [k, v] of strMap) {
        obj[k] = v;
      }
      return obj;
    },
    choseWorkServiceItem() {
      // findItemsByCategory(this.joinsWorkServiceCategory.id).then(res => {
      //   let data = JSON.parse(res.data);
      //   this.joinsWorkServiceItems = data;
      // });
      let params = {};
      params.superiorId = this.joinsWorkServiceCategory.id;
      findProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
    },
    findCoupon() {
      let obj = {};
      obj.serviceCategoryId = this.joinsWorkServiceCategory.id;
      obj.serviceItemId = this.joinsWorkServiceItem.id;
      findCoupon(obj).then((res) => {
        let data = JSON.parse(res.data);
        this.coupons = data;
      });
    },
    clean() {
      this.currProvince = [];
      this.currCity = [];
      this.currArea = [];
      this.citys = [];
      this.areas = [];
      this.brand = {};
      this.classify = {};
      this.secondClassify = {};
      this.sku = {};
      this.form = {
        priceName: '',
        parentCommissionRateType: '',
        commissionRateType: '',
      };
      this.currProduct = {};
      this.joinsWorkServiceCategory = {};
      this.joinsWorkServiceItem = {};
      this.coupon = {};
      this.skuList = [];
      this.tableData1 = [];
      this.constitutes = [];
      this.dataSku1 = [];
      this.describeImgs = [];
      this.wheelsImgs = [];
      this.isEdit = false;
      this.currservicePeople = [];
      this.currservicePeoples = [];
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
